//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as guideAction from '../action/guideAction';
//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';
import { UAParser } from 'ua-parser-js';
//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
//import Button from '@material-ui/core/Button';
//Icon
import CloseIcon from '@material-ui/icons/Close';

import imgAppIcon from '../img/app/app_icon.png';
import imgAppScreenSearch from '../img/app/app_screen_search.png';
import imgAppScreenProfile from '../img/app/app_screen_profile.png';
import imgAppIos from '../img/app/app_link_button_ios.png';
import imgAppAndroid from '../img/app/app_link_button_android.png';

//import imgAppApk from '../img/app/app_link_button_apk.png';

//import imgQrIos from '../img/app/app_qr_ios.png';
//import imgQrAndroid from '../img/app/app_qr_android.png';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loginUrl: null,
    }
  }


  _loginUrlLink() {
    let ua = UAParser();
    if (ua.device.type !== 'mobile' && ua.device.type !==  'tablet') {
      alert('アプリはスマートフォンかタブレットでアクセスするとインストールできます。');
      return false;
    }
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    return axios.post(config.apiUri + "member/loginUrlApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      let uri = 'https://web2app.partner-s.net/G8uJ?af_xp=custom&pid=web2app&deep_link_value=urlLogin&deep_link_sub1=' + res.data.uic + '&deep_link_sub2=' + res.data.token;
      console.log(uri);
      if (!window.open(uri)){
        window.location.href = uri;
      }
      else {
        window.open(uri, '_blank');
      }
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }

	render() {

		return (
      <Dialog
        fullScreen
        open={this.props.guide.app.visible}
        onClose={ () => {
          this.setState({loginUrl: null});
          this.props.guideAppSet(false);
        }}
        TransitionComponent={Transition}
        style={{maxWidth:'600px', margin:'auto'}}
        scroll='paper'
      >
        <div style={{width:'100%',zIndex:'100'}} className='shadow'>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              アプリをインストールする
            </div>
            <div>
              <IconButton onClick={ () => {
                this.setState({loginUrl: null});
                this.props.guideAppSet(false);
              }}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </div>
        <DialogContent>
          <div style={{margin:'15px'}}>
            <div style={{margin:'10px'}}>
              アプリはダウンロードすれば、アカウントが連携されるのでログイン操作なしでそのまま利用できます。<br/>
              ワンクリックで便利なアプリに切り替えてみませんか?
            </div>

          </div>
          <div style={{padding:'10px',position:'relative'}} align='center'>

              <img
                src={ imgAppIcon }
                style={{height:'auto', width:'12%', position:'absolute', left:'20%', top:0}}
                alt=''
              />

              <img
                src={ imgAppScreenProfile }
                style={{height:'auto',width:'30%',maxWidth:'150px'}}
                alt=''
              />
              <img
                src={ imgAppScreenSearch }
                style={{height:'auto',width:'30%',maxWidth:'150px'}}
                alt=''
              />


          </div>
          <div style={{padding:'10px'}} align='center'>
            <div style={{margin:'15px'}}>

              <Grid container  justifyContent="center" alignItems="center" spacing={3}>
                <Grid item>
                  <div style={{color:'#333',fontSize:'0.9em'}}>
                    iOSアプリ
                  </div>
                  <span onClick={ () => this._loginUrlLink()} style={{cursor: 'pointer'}}>
                    <img
                      src={ imgAppIos }
                      style={{height:'50px',width:'auto'}}
                      alt=''
                    />
                  </span>
                </Grid>

                <Grid item>
                  <div style={{color:'#333',fontSize:'0.9em'}}>
                    Androidアプリ
                  </div>

                  <span onClick={ () => this._loginUrlLink()} style={{cursor: 'pointer'}}>
                    <img
                      src={ imgAppAndroid }
                      style={{height:'50px',width:'auto'}}
                      alt=''
                    />
                  </span>
                </Grid>

              </Grid>
            </div>
          </div>
          <div style={{margin:'15px'}}>
            <ol style={{margin:'5px 5px 5px 25px',color:'#333'}}>
              <li>アプリをダウンロードしてください。</li>
              <li>アプリが起動するとご利用中のアカウントで自動的にログインします。</li>
            </ol>

          </div>
          <div style={{margin:'15px'}}>
            <div style={{fontSize:'0.9em',color:'#666'}}>
              アプリでご利用後でもブラウザ版からもご利用いただけます。
            </div>
            <div style={{fontSize:'0.9em',color:'#666'}}>
              ※アプリ内の決済とブラウザ版からの有料サービスはご料金が異なります。
              ブラウザ版で有料サービスにお申し込みいただいてアプリでご利用いただくことも可能です。
            </div>
          </div>
        </DialogContent>
      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
		guide: state.guide,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
